import ContextPadProvider from './contextPadProvider'
export default {
    __init__: [
      'ContextPadProvider',
    ],
    ContextPadProvider: [ 'type', ContextPadProvider ]
};